module.exports = "<p>\n  company-demands works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/company-modal/company-demands/company-demands.component.html
// module id = ../../../../../src/app/_components/company-modal/company-demands/company-demands.component.html
// module chunks = main